export enum PartnerType {
    Mews = 0,
    Referral = 1,
}
